import React from 'react'
import { getRegistrationUrl } from 'src/dataLayer/env'
import { useAppConfigContext } from 'src/viewLayer/components/contexts/AppConfigContext'
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext'
import { Inline, Text } from 'src/viewLayer/components/DesignSystem'
import TrackableLink from 'src/viewLayer/components/shared/TrackableLink'
import { t } from 'src/viewLayer/helpers/translations'

export default () => {
  const { locale, queryParams } = useRouteParamsContext()
  const { devicePath } = useAppConfigContext()

  if (devicePath !== 'login') {
    return null
  }

  return (
    <Inline align="center" alignItems="center" gap={3}>
      <Text fontSize="small">{t('email.links.signup_question')}</Text>
      <TrackableLink
        data-testid="signup-link"
        href={getRegistrationUrl(locale, queryParams)}
        size="small"
        trackingId={'signup_link'}
        weight="strong"
      >
        {t('email.links.signup_action')}
      </TrackableLink>
    </Inline>
  )
}
